import type { z } from "zod";

import type { TimelineOverrideSchema } from "./runtypes/TimelineStageSchema.js";

export const createTimelineOverride = (): z.infer<
  typeof TimelineOverrideSchema
> => ({
  distributionMethod: null,
  distribution: [],
  frameRange: { lower: null, upper: null },
});
